import { useCurrentRouteConfig } from '#src/app/routes';

import { FEATURED_PETITION_SLUG, QUALIFYING_ROUTE_IDS } from '../../shared/constants';

/**
 * A *qualifying surface* is the homepage, search, or a petition-details page — excluding the
 * featured petition's own page (behavior 5). Bot-share petition-details route variants
 * (`petition-details-victory`, `petition-details-bsv`, …) are deliberately not qualifying.
 */
export function useQualifyingSurface(): boolean {
	const currentRoute = useCurrentRouteConfig();

	if (!currentRoute) return false;

	const {
		config: { id },
		params,
	} = currentRoute;

	if (!(QUALIFYING_ROUTE_IDS as readonly string[]).includes(id)) return false;

	// The featured petition's own page never shows the toast.
	if (id === 'petition-details' && params.slug === FEATURED_PETITION_SLUG) return false;

	return true;
}
